import { render } from "./BestFeatures.vue?vue&type=template&id=0cdb2049"
import script from "./BestFeatures.vue?vue&type=script&lang=js"
export * from "./BestFeatures.vue?vue&type=script&lang=js"

import "./BestFeatures.vue?vue&type=style&index=0&id=0cdb2049&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__